/* eslint no-void: ["error", { "allowAsStatement": true }] */
export const repaint = (node: HTMLElement): void => {
  void (node.offsetHeight);
};

export default {
  repaint,
};
